import styled from "@emotion/styled";
import { Text } from "@repo/skapa";
import { PaddedContainer } from "@repo/ui";
import { type PropsWithChildren } from "react";

import { ErrorBoundary } from "./ErrorBoundary";

const FullScreenContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const FallbackErrorBoundary = ({
  errorMessage,
  children,
}: PropsWithChildren<{
  errorMessage: string;
}>) => {
  return (
    <ErrorBoundary fallback={<Text>{errorMessage}</Text>}>
      {children}
    </ErrorBoundary>
  );
};

export const FallbackFullscreenErrorBoundary = ({
  errorMessage,
  children,
}: PropsWithChildren<{
  errorMessage: string;
}>) => {
  return (
    <ErrorBoundary
      fallback={
        <FullScreenContainer>
          <Text>{errorMessage}</Text>
        </FullScreenContainer>
      }
    >
      {children}
    </ErrorBoundary>
  );
};

export const FallbackSectionErrorBoundary = ({
  errorMessage,
  children,
}: PropsWithChildren<{
  errorMessage: string;
}>) => {
  return (
    <ErrorBoundary
      fallback={
        <PaddedContainer>
          <Text>{errorMessage}</Text>
        </PaddedContainer>
      }
    >
      {children}
    </ErrorBoundary>
  );
};
